<div *transloco="let t; read: 'bpTask'" class="p-2">
    <mat-stepper linear #stepper>
        <mat-step>
            <ng-template matStepLabel>
                {{ t('aif.selectIO') }}
            </ng-template>
            <ng-template matStepContent>
                <div class="flex flex-col gap-2">
                    <aif-dialog-item
                        [isSelected]="selectedIO() === 'input'"
                        (click)="selectIO('input')">
                        {{ t('aif.input') }}
                    </aif-dialog-item>
                    <aif-dialog-item
                        [isSelected]="selectedIO() === 'output'"
                        (click)="selectIO('output')">
                        {{ t('aif.output') }}
                    </aif-dialog-item>
                    <div class="flex flex-row justify-end gap-2">
                        <button
                            [disabled]="!selectedIO()"
                            color="primary"
                            mat-raised-button
                            matStepperNext>
                            {{ t('aif.next') }}
                        </button>
                    </div>
                </div>
            </ng-template>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>
                {{ t('aif.selectItem') }}
            </ng-template>
            <ng-template matStepContent>
                <div class="flex flex-col gap-2">
                    <aif-dialog-item
                        *ngFor="let item of items(); trackBy: trackByFn"
                        [isSelected]="selectedItem()?.description === item.description"
                        (click)="selectItem(item)">
                        {{ item.description }}
                    </aif-dialog-item>
                    <div class="flex flex-row justify-end gap-2">
                        <button mat-button matStepperPrevious> {{ t('aif.back') }} </button>
                        <button
                            [disabled]="!selectedItem()"
                            color="primary"
                            mat-raised-button
                            matStepperNext>
                            {{ t('aif.next') }}
                        </button>
                    </div>
                </div>
            </ng-template>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>
                {{ t('aif.selectField') }}
            </ng-template>
            <ng-template matStepContent>
                <custom-table
                    [filter]="true"
                    tableName="selectServiceTable"
                    [displayedColumns]="displayedColumns()"
                    [dataSource]="dataSource()"
                    [selectedRows]="selection()"
                    [enableRowSelection]="true"
                    [enableMultipleRowSelection]="true"
                    (onRowsSelected)="onRowSelected($event)"
                    [enablePagination]="true"></custom-table>
                <div class="flex flex-row justify-end gap-2">
                    <button mat-button matStepperPrevious> {{ t('aif.back') }} </button>
                    <button
                        [disabled]="!selection()?.length"
                        color="primary"
                        mat-raised-button
                        (click)="selectFields()">
                        {{ t('aif.select') }}
                    </button>
                </div>
            </ng-template>
        </mat-step>
    </mat-stepper>
</div>
